export class WarehouseListResponse {
  content: WarehouseListContent[];
}

export interface Warehouse {
  id: string;
  code: string;
  wmsCode: string;
  name: string;
  locationDisplay: string;
  defaultFirstLot: boolean;
  allStorageTypes: string[];
  defaultStorageType: string[];
  splitStorageTypes: string[][];
}

export class WarehouseListContent {
  id: string;
  code: string;
  name: string;
  type: string;
  wmsCode: string;
  warehouseNameDisplay: string;
  defaultFirstLot: boolean;
  operator: string;
  orderFlow: string[];
  crossDockSupplier: string[];
  allStorageTypes: string[];
  defaultStorageType: string[];
  splitStorageTypes: string[][];

  constructor(data: WarehouseListContent) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.type = data.type;
    this.wmsCode = data.wmsCode;
    this.warehouseNameDisplay = data.warehouseNameDisplay;
    this.defaultFirstLot = data.defaultFirstLot;
    this.operator = data.operator;
    this.orderFlow = data.orderFlow;
    this.crossDockSupplier = data.crossDockSupplier;
    this.splitStorageTypes = data.splitStorageTypes;
    this.defaultStorageType = data.defaultStorageType;
    this.allStorageTypes = data.allStorageTypes;
  }
}

export class SelectWarehouseList {
  id: string;
  code: string;
  wmsCode: string;
  name: string;
  locationDisplay: string;
}

export class SelectWarehousePagingList {
  masterDtoList: SelectWarehouseList[];
  totalElement: number;
}

export class WarehousesStoresSearchCriteria {
  isPaging?: boolean;
  searchCriteria?: string;
  isWarehouse?: boolean;
  module?: string;
  page?: number;
  size?: number;
}

export class BillToBase {
  code: string;
  nameEn: string;
  nameTh: string;
  contactName: string;
  contactNumber: string;
  address: string;
  fullNameTh: string;
  fullNameEn: string;
  wmsCode: string;
}

export class OfficeWarehouse extends BillToBase {
  billTo: BillToBase;
}

export class WarehouseMasterData {
  offices: OfficeWarehouse[];
  warehouses: OfficeWarehouse[];
}

export class BillingMasterData {
  billings: BillToBase[];
}
